export const isBelowLength =
  (length: number) =>
  (value: string | undefined): boolean => {
    if (typeof value !== 'undefined') {
      return value.length <= length;
    }
    return false;
  };
